@if (endSureDropDown$ | async; as dropDownData) {
  <div class="my-account-section">
    <div class="col-sm-12 col-md-12 col-lg-3 my-account-left-section endasureLeft">
      <app-endasure-left></app-endasure-left>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-9 my-account-right-section endasureRight">
      @if (currentComponent === 'visitorInfo') {
        <app-endasure-vistor-info></app-endasure-vistor-info>
      }
      @if (currentComponent === 'fleetInfo') {
        <app-endasure-fleet-info></app-endasure-fleet-info>
      }
      @if (currentComponent === 'replacementCost') {
        <app-endasure-replacement-cost></app-endasure-replacement-cost>
      }
      @if (currentComponent === 'currentProduct') {
        <app-endasure-current-product
          [brandOfActuator]="dropDownData"
        ></app-endasure-current-product>
      }
      @if (currentComponent === 'csaDowntime') {
        <app-endasure-csa-downtime></app-endasure-csa-downtime>
      }
      @if (currentComponent === 'endurasurePro') {
        <app-endasure-pro></app-endasure-pro>
      }
      @if (currentComponent === 'endurasureSummary') {
        <app-endasure-summary></app-endasure-summary>
      }
    </div>
  </div>
}
